<style scoped></style>

<template>
    <contentBlock>
        <h1>{{ $t('site.contact.us') }}</h1>

        <div class="flex flex-wrap justify-between">
            <div>
                <div class="mb-10">
                    <h2>
                        客戶服務:
                    </h2>
                    <div class="w-full flex">
                        <div class="w-32 flex-shrink-0">
                            電話:
                        </div>
                        <div>
                            +852 2784 2838
                        </div>
                    </div>
                    <div class="w-full flex">
                        <div class="w-32 flex-shrink-0">
                            電郵:
                        </div>
                        <div>
                            <a href="mailto:cs@tryhala.com" target="_blank">
                                cs@tryhala.com
                            </a>
                        </div>
                    </div>
                </div>
                <div class=" mb-10">
                    <h2>
                        其他查詢:
                    </h2>
                    <div class="w-full flex">
                        <div class="w-32 flex-shrink-0">
                            電話:
                        </div>
                        <div>
                            +852 2784 2819
                        </div>
                    </div>
                    <div class="w-full flex">
                        <div class="w-32 flex-shrink-0">
                            電郵:
                        </div>
                        <div>
                            <a
                                href="mailto:enquiry@tryhala.com"
                                target="_blank"
                            >
                                enquiry@tryhala.com
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full max-w-2xl">
                <h2>{{ $t('site.contact.us') }}</h2>
                <contactUsEnquiryForm
                    submitBtnClass="btn-primary"
                    submitBtnPanelClass="sm:pl-32"
                >
                    <template #form="{form, errors}">
                        <div class="w-full">
                            <formFieldRow
                                name="contactName"
                                :label="$t('about.us.enquiry.contactName')"
                                :errors="errors"
                                class="field-contactName w-full"
                            >
                                <template #default="{ hasError }">
                                    <input
                                        class="form-input w-full"
                                        :class="{ 'border-red': hasError }"
                                        type="text"
                                        maxlength="100"
                                        v-model.trim="form.contactName"
                                    />
                                </template>
                            </formFieldRow>
                            <formFieldRow
                                name="contactEmail"
                                :label="$t('about.us.enquiry.contactEmail')"
                                :errors="errors"
                                class="field-contactEmail w-full"
                            >
                                <template #default="{ hasError }">
                                    <input
                                        class="form-input w-full"
                                        :class="{ 'border-red': hasError }"
                                        type="email"
                                        maxlength="50"
                                        v-model.trim="form.contactEmail"
                                    />
                                </template>
                            </formFieldRow>
                            <formFieldRow
                                name="contactPhone"
                                :label="$t('about.us.enquiry.contactPhone')"
                                :errors="errors"
                                class="field-contactPhone w-full"
                            >
                                <template #default="{ hasError }">
                                    <input
                                        class="form-input w-full"
                                        :class="{ 'border-red': hasError }"
                                        type="tel"
                                        maxlength="50"
                                        v-model.trim="form.contactPhone"
                                    />
                                </template>
                            </formFieldRow>
                            <formFieldRow
                                name="message"
                                :label="$t('about.us.enquiry.message')"
                                :errors="errors"
                                class="field-message w-full"
                            >
                                <template #default="{ hasError }">
                                    <textarea
                                        class="form-input w-full h-auto"
                                        :class="{ 'border-red': hasError }"
                                        maxlength="1000"
                                        rows="5"
                                        v-model.trim="form.message"
                                    />
                                </template>
                            </formFieldRow>
                        </div>
                    </template>
                </contactUsEnquiryForm>
            </div>
            <div class="remind-message-container w-full text-center">
                請把我們的系統電郵地址
                <a href="mailto:cs@tryhala.com">cs@tryhala.com</a>
                加入為聯絡人，以免您的電郵系統把回覆誤當為垃圾郵件
            </div>
        </div>
    </contentBlock>
</template>

<script>
import contentBlock from '@/components/contentBlock.vue';
import contactUsEnquiryForm from '@/components/contactUsEnquiryForm.vue';
import formFieldRow from '@/components/formFieldRow.vue';

export default {
    components: { contentBlock, contactUsEnquiryForm, formFieldRow }
};
</script>
